import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';
import { Checkbox } from '../../../_models/checkbox';
import { MatIcon } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule, FormGroup } from '@angular/forms';

@Component({
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, MatIcon],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckboxComponent {
  title: 'Checkbox';
  component: '';

  /** Checkbox params (required) */
  checkbox = input<Checkbox>();

  /** Parent FormGroup containing the control (required) */
  parentForm = input<FormGroup>();

  /** Is the input disabled? (optional, default: false) */
  isDisabled = input<boolean>(false);

  /** Emit selected option */
  checkboxSelected = output<boolean>();

  onValueChange = (event: Event): void => {
    const target = event.target as HTMLInputElement;
    this.checkboxSelected.emit(target.checked as boolean);
  };
}
